import { css } from '@emotion/react';

export const mainContainer = css`
  position: relative;
  width: max-content;
  height: auto;
  overflow: hidden; /* Ensure the shine doesn't overflow */

  &.isDisabled {
    filter: invert(100%);
  }

  /* Shine effect */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -75%;
    width: 50%;
    height: 100%;
    background: linear-gradient(
      120deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.4) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    transform: skewX(-25deg);
    pointer-events: none;
    z-index: 4;
  }

  &:hover::before {
    animation: shine 0.8s ease-in-out;
  }

  @keyframes shine {
    0% {
      left: -75%;
    }
    100% {
      left: 125%;
    }
  }
`;

export const iconContainer = css`
  position: absolute;

  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);

  &:not(.isNeutral) {
    mix-blend-mode: luminosity;
  }

  z-index: 3;
`;

export const childrenContainer = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
`;
